export enum FileContextNameEnum {
  Advance = 0,
  UserArtist = 1,
  Chat = 2,
}
